import { render } from "./CourseItems.vue?vue&type=template&id=1c7d21e3&scoped=true"
import script from "./CourseItems.vue?vue&type=script&lang=js"
export * from "./CourseItems.vue?vue&type=script&lang=js"

import "./CourseItems.vue?vue&type=style&index=0&id=1c7d21e3&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c7d21e3"]])

export default __exports__